import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type TError = string[]

const initialState : any = []

// Create a slice
const adminErrorSlice = createSlice({
    name: 'adminError',
    initialState,
    reducers: {
        addError: (state, action) => {
            state.push(action.payload)
        },
        setErrors: (state, action)=>{
            return action.payload
        },
        clearErrors: state => {
            return []
        }
    }
})

// Export the actions and reducer
export const { addError, setErrors, clearErrors } = adminErrorSlice.actions
export default adminErrorSlice.reducer
